import { render, staticRenderFns } from "./FrequentlyAsked.vue?vue&type=template&id=7536e362&"
import script from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAsked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports